<template>
  <div class="container">

    <!-- HEADER -->
    <div class="header">
      <img :src="logo" class="logo" />
      <h1 class="title">BẾP A DIỂNG</h1>
      <p class="subtitle">Cơm ngon chẳng sợ lạ – Cứ ăn là thấy nhà</p>
    </div>

    <!-- MENU -->
    <div class="menu">
      <div
          v-for="item in menuItems"
          :key="item.name"
          class="menu-item"
      >
        <div class="menu-left">
          <p class="name">{{ item.name }}</p>
          <p class="desc">{{ item.desc }}</p>
        </div>
        <div class="price">{{ item.price }}</div>
      </div>
    </div>

    <!-- NOTE -->
    <div class="note">
      Một phần ăn kèm rau/salad và canh theo ngày
    </div>

    <!-- EXTRA -->
    <div class="extra-box">

      <p class="extra-title">
        Phục vụ cùng canh, rau theo ngày và món phụ
      </p>

      <div class="extra-grid">

        <div>
          <p class="group-title">Thịt Thêm</p>
          <p v-for="item in extraMeat" :key="item">{{ item }}</p>
        </div>

        <div>
          <p class="group-title">Topping thêm</p>
          <p v-for="item in toppings" :key="item">{{ item }}</p>
        </div>

        <div>
          <p class="group-title">Đồ Uống</p>
          <p v-for="item in drinks" :key="item">{{ item }}</p>
        </div>

      </div>
    </div>

    <!-- FOOTER -->
    <div class="footer">
      <p>📍 Shop online - Lấy đồ trực tiếp tại: 8/5/89 Lê Lợi - Ngô Quyền - Hải Phòng</p>

      <p>📞 0965396425</p>
      <p>⏰ 10:00 - 14:00</p>
    </div>

  </div>
</template>

<script setup>
import logo from '@/assets/logoadieng.png'

const menuItems = [
  { name: "Cơm thịt kho tàu", desc: "Đặc sản nhà Diểng, mềm tan.", price: "45K" },
  { name: "Cơm thịt khâu nhục", desc: "Thịt hấp mềm rục.", price: "50K" },
  { name: "Cơm bò fuji hầm", desc: "Nước hầm ngọt tự nhiên.", price: "50K" },
  { name: "Cơm bò fuji nướng", desc: "Nướng xém mặt thơm.", price: "45K" },
  { name: "Cơm cá mòi kho", desc: "Xương mềm rục.", price: "45K" },
  { name: "Cơm gà tiêu đen", desc: "Thơm cay nhẹ.", price: "45K" },
  { name: "Cơm gà sả ớt", desc: "Thơm mùi sả.", price: "45K" }
]

const extraMeat = [
  "Thịt ba chỉ hấp: 25K",
  "Cá kho: 20K",
  "Thịt bò: 30K",
  "Thịt gà: 20K"
]

const toppings = [
  "Trứng ốp: 8K",
  "Chả mỡ: 10K",
  "Đậu rim: 10K",
  "Cá ruội: 10K"
]

const drinks = [
  "Trà đá",
  "Nước giải khát",
  "Bia"
]
</script>

<style scoped>
body {
  font-family: 'Times New Roman', serif;
}

/* LAYOUT */
.container {
  max-width: 700px;
  margin: auto;
  padding: 40px 20px;
  background: #f7efe0;
  color: #4b1e1e;
}

/* HEADER */
.header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 110px;
  margin-bottom: 10px;
}

.title {
  font-size: 40px;
  letter-spacing: 6px;
  font-weight: bold;
}

.subtitle {
  font-style: italic;
  margin-top: 10px;
}

/* MENU */
.menu-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #4b1e1e;
  padding-bottom: 8px;
  margin-bottom: 12px;
}

.menu-left {
  padding-right: 10px;
}

.name {
  font-weight: bold;
}

.desc {
  font-size: 14px;
  font-style: italic;
}

.price {
  white-space: nowrap;
}

/* NOTE */
.note {
  text-align: center;
  margin-top: 20px;
  font-style: italic;
  font-size: 14px;
}

/* EXTRA */
.extra-box {
  border: 1px solid #4b1e1e;
  padding: 20px;
  margin-top: 30px;
}

.extra-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}

.extra-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.group-title {
  font-weight: bold;
  margin-bottom: 10px;
}

/* FOOTER */
.footer {
  text-align: center;
  margin-top: 30px;
  font-size: 14px;
}

/* MAP */
.map {
  width: 100%;
  height: 300px;
  margin-top: 20px;
  border: none;
}
</style>